import { CategoryType, PostType } from '@/libs/types'
import { Utils } from '@/libs/Utils'
import clsx from 'clsx'
import Link from 'next/link'
import React from 'react'

interface CardCategoryOneProps {
    category: CategoryType
    knowledges: Array<PostType>
    locale: string
}

const CardCategoryOne: React.FC<CardCategoryOneProps> = ({ knowledges = [], category = {}, locale }) => {

    const t = new Utils(locale).Translation

    return (
        <div className="col-md-4 col-12 mb-4">
            <div className="card__one__article h-100 p-5 bg-white rounded category">
                <div>
                    <p className="category__title mb-3 fw-bold">
                        {category.attributes?.name}
                    </p>
                    {category.attributes?.description &&
                        <p className="category__description">
                            {category.attributes?.description}
                        </p>}
                    <hr />
                    <div className="mb-0 small knowledge__article" >
                        {knowledges.map((knowledge: PostType, index: number) => {
                            if (index >= 5) return null;

                            const { slug, title } = knowledge.attributes

                            const href = `/${locale}/knowledges/${category?.attributes?.slug}/${slug.split(",").join("/")}`

                            return (
                                <Link href={href}
                                    className={clsx("text-decoration-none")}
                                    key={index}
                                    passHref
                                >
                                    <span>
                                        {title}
                                    </span>
                                </Link>
                            )
                        })}
                        <hr />
                        <div className="knowledge__article__summary mb-0">
                            <p className="mb-0 d-flex justify-content-end align-items-center text-muted">{knowledges.length} {t("articles")} </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CardCategoryOne